import * as React from 'react';
const SvgLegacy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={240}
    height={240}
    viewBox="0 0 240 240"
    {...props}
  >
    <path
      fill="#e9f2ff"
      d="M120.43 204.36c46.39 0 84-37.61 84-84s-37.61-84-84-84-84 37.6-84 84 37.61 84 84 84"
    />
    <path
      fill="#8bf"
      fillRule="evenodd"
      d="M24.83 51.82a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
    />
    <path
      fill="#59f"
      d="M186.02 192.24c.53-2.21 3.67-2.21 4.21 0l.71 2.94c.19.79.81 1.41 1.6 1.6l2.93.71c2.21.53 2.21 3.68 0 4.21l-2.93.71c-.79.19-1.41.81-1.6 1.6l-.71 2.94c-.53 2.21-3.67 2.21-4.21 0l-.71-2.94a2.17 2.17 0 0 0-1.6-1.6l-2.93-.71c-2.21-.53-2.21-3.68 0-4.21l2.93-.71a2.17 2.17 0 0 0 1.6-1.6z"
    />
    <path
      fill="#cdf"
      d="M100.24 32.8c-.37-1.47 1-2.78 2.46-2.37l8.04 2.28c1.46.42 1.92 2.25.83 3.3l-6.01 5.78c-1.09 1.05-2.92.53-3.29-.93l-2.03-8.07Z"
    />
    <path
      fill="#cdf"
      fillRule="evenodd"
      d="M150.09 219.75a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.61c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
    />
    <path
      fill="#59f"
      d="M214.45 53.59c1.37-.24 2.48 1.09 2 2.39l-2.62 7.15c-.48 1.3-2.18 1.6-3.07.54l-4.9-5.84c-.89-1.06-.3-2.69 1.07-2.92l7.51-1.31ZM27.88 154.74c1.37-.24 2.48 1.09 2 2.39l-2.62 7.15c-.48 1.3-2.18 1.6-3.07.54l-4.9-5.84c-.89-1.06-.3-2.69 1.07-2.92l7.51-1.31ZM127.74 196l-86.5-22.13V83.88l86.5 22.13z"
    />
    <path fill="#16e" d="m127.74 196 71.02-23.86V82.15l-71.02 23.86z" />
    <path fill="#16e" d="m198.76 82.15-71.02 23.86-86.5-22.13 69.19-21.96z" />
    <path fill="#137" d="m127.74 106.01 71.02-23.86-88.33-20.23v39.67z" />
    <path
      fill="#59f"
      d="M88.72 90.5c0 3.64 2.32 7.04 6.13 8.21.77.24 1.58.32 2.39.32h28.2c2.78-.01 5.45-1.12 7.43-3.08a10.73 10.73 0 0 0 3.18-7.4c.06-2.79-.97-5.49-2.87-7.53s-4.51-3.25-7.29-3.39a15.1 15.1 0 0 0-6.53-6.94 15.02 15.02 0 0 0-17.84 2.72 15.1 15.1 0 0 0-4.17 8.57h-.14c-.78 0-1.57.08-2.32.31-3.83 1.16-6.17 4.56-6.17 8.2ZM50.12 67.72c0 3.23 2.06 6.25 5.45 7.29.68.21 1.4.28 2.12.28h25.05c2.47-.01 4.84-.99 6.6-2.73a9.57 9.57 0 0 0 2.83-6.58c.05-2.48-.86-4.88-2.55-6.69a9.5 9.5 0 0 0-6.48-3.01 13.37 13.37 0 0 0-5.8-6.16 13.3 13.3 0 0 0-8.32-1.44c-2.86.44-5.5 1.79-7.52 3.86a13.44 13.44 0 0 0-3.71 7.61h-.12c-.7 0-1.4.07-2.06.27-3.4 1.03-5.48 4.05-5.49 7.29Z"
    />
    <path
      fill="#cdf"
      d="M38.53 195.41c0 4.47 2.85 8.65 7.54 10.09.95.29 1.94.39 2.93.39h34.65c3.42-.02 6.69-1.37 9.13-3.78a13.177 13.177 0 0 0 .39-18.34c-2.33-2.51-5.55-4-8.96-4.16-1.68-3.64-4.5-6.63-8.02-8.52-3.52-1.9-7.56-2.6-11.51-1.99-3.95.6-7.6 2.48-10.4 5.34s-4.6 6.56-5.13 10.53h-.17c-.96 0-1.93.1-2.85.38-4.71 1.42-7.58 5.6-7.59 10.08ZM102.39 144.17 15.9 119.99l25.34-36.11 86.5 22.13zM153.08 144.17l71.02-25.91-25.34-36.11-71.02 23.86z"
    />
    <path
      fill="#cdf"
      d="m170.843 76.542 4.954-2.819 29.628 52.071-4.954 2.819z"
    />
    <path
      fill="#fff"
      d="M160.75 80.6c-9.91 0-19.11-5.34-24-13.95-3.64-6.4-4.58-13.84-2.62-20.95s6.55-13.03 12.96-16.67a27.53 27.53 0 0 1 13.61-3.62c9.91 0 19.11 5.34 24 13.95 7.52 13.22 2.89 30.1-10.33 37.62a27.53 27.53 0 0 1-13.61 3.62Z"
    />
    <path
      fill="#59f"
      d="M160.69 21.41v8c8.48 0 16.34 4.57 20.53 11.93 3.12 5.48 3.91 11.84 2.24 17.91-1.67 6.08-5.6 11.14-11.08 14.25a23.6 23.6 0 0 1-11.64 3.09c-8.48 0-16.34-4.57-20.53-11.93-3.12-5.48-3.91-11.84-2.24-17.91 1.67-6.08 5.6-11.14 11.08-14.25 3.55-2.02 7.58-3.09 11.64-3.09zm0 0c-5.29 0-10.66 1.33-15.59 4.14-15.16 8.63-20.46 27.91-11.83 43.07 5.82 10.23 16.5 15.97 27.48 15.97 5.29 0 10.66-1.33 15.59-4.14 15.16-8.63 20.46-27.91 11.83-43.07-5.82-10.23-16.5-15.97-27.48-15.97"
    />
    <rect
      width={11.88}
      height={57.12}
      x={187.42}
      y={81.8}
      fill="#59f"
      rx={4.54}
      ry={4.54}
      transform="rotate(-29.64 193.384 110.372)"
    />
  </svg>
);
export default SvgLegacy;
